import React from 'react';
import PropTypes from 'prop-types';
import Wangeditor from 'wangeditor';
import './style.less';
class RichText extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.editor = null;
    }

    componentDidMount() {
        const { defaultValue = '', onChange, disabled } = this.props;
        const elemMenu = this.editorElemMenu;
        const elemBody = this.editorElemBody;
        if (!elemMenu || !elemBody) return;
        this.editor = new Wangeditor(elemMenu, elemBody);
        // 使用 onchange 函数监听内容的变化，并实时更新到 state 中
        this.editor.config.onchange = html => {
            onChange && onChange(encodeURI(html));
        };
        this.editor.config.menus = [
            'head', // 标题
            'bold', // 粗体
            'fontSize', // 字号
            'fontName', // 字体
            'italic', // 斜体
            'underline', // 下划线
            'strikeThrough', // 删除线
            'foreColor', // 文字颜色
            'backColor', // 背景颜色
            'link', // 插入连接
            'list', // 列表
            'justify', // 对齐方式
            'quote', // 引用
            // 'emoticon', // 表情
            // 'image', // 插入图片
            'table', // 表格
            // 'video', // 插入视频
            // 'code', // 插入代码
            'undo', // 撤销
            'redo', // 重复
        ];
        this.editor.create();
        // 设置初始内容
        this.editor.txt.html(decodeURI(defaultValue));
        // 禁用
        disabled && this.editor.disable();
    }

    setHtml = code => {
        this.editor.txt.html(decodeURI(code));
    };

    componentWillUnmount() {
        // 销毁富文本
        this.editor && this.editor.destroy();
    }

    render() {
        const { disabled = false } = this.props;
        const height = disabled ? '100%' : 'calc(100% - 40px)';
        return (
            <div className="richTextBox">
                {/* 顶部菜单栏 */}
                <div
                    ref={ref => (this.editorElemMenu = ref)}
                    style={{
                        display: disabled ? 'none' : 'block',
                    }}
                    className="editorElem-menu"></div>
                {/* 文本框 */}
                <div
                    ref={ref => (this.editorElemBody = ref)}
                    className="editorElem-body"
                    style={{
                        height,
                    }}></div>
            </div>
        );
    }
}

export default RichText;

RichText.propTypes = {
    defaultValue: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
};

/* 富文本组件应用实例
    <RichText 
        defaultValue={''}   //初始值
        onChange={onRichTextChange} //文本改变回调，获取文本值
        disabled={false} //是否禁用
    />
*/
